<script setup lang="ts">
  import { computed, PropType } from 'vue'
  import type { GIPointCollection } from '@/stores/type/giPoint.type'
  import { useGIDataUploadCollectionStore } from '@/stores/giDataUploadCollection'
  import { useEventsBus } from '@haskoning/vue-component-library'

  const emit = defineEmits(['edit', 'delete', 'selected'])
  const { emit: busEmit } = useEventsBus()
  const props = defineProps({
    store: {
      type: Object,
      required: true
    },
    item: {
      type: Object as PropType<GIPointCollection>,
      required: true
    },
    isSelecting: { type: Boolean, required: false, default: false }
  })
  const giDataUploadCollectionsStore = useGIDataUploadCollectionStore()
  const authorizationStore = useAuthorizationStore()
  const { selectedItemIDs } = storeToRefs(giDataUploadCollectionsStore)
  const isSelected = computed(() => {
    const isSelectedItemsIncludeID = selectedItemIDs.value.includes(props.item.id)
    emit('selected', isSelectedItemsIncludeID)
    return isSelectedItemsIncludeID
  })

  const canUpdate = computed(() =>
    authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: ['change_gidatauploadcollection']
    })
  )

  const canDelete = computed(() =>
    authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: ['delete_gidatauploadcollection']
    })
  )
</script>

<template>
  <v-list-item-title class="d-flex justify-space-between">
    <div class="d-flex align-center justify-start g-2 w-100 ml-2">
      <v-checkbox
        v-if="!props.isSelecting"
        color="primary"
        density="compact"
        v-model="isSelected"
        hide-details
        @click.stop="giDataUploadCollectionsStore.toggleSelectedGIPointCollection(props.item)"
        class="ml-n1"
      ></v-checkbox>
      <v-icon :color="props.item.collection_color">mdi-circle</v-icon>
      <div @click.stop="busEmit('fly-to-gi-collection', props.item)" class="text-primary">
        <strong> {{ props.item.name }}</strong>
      </div>
      <v-icon v-if="canUpdate" color="primary" class="cursor-pointer" @click.stop="emit('edit')"
        >mdi-pencil</v-icon
      >
    </div>
  </v-list-item-title>
</template>

<style scoped></style>
